// extracted by mini-css-extract-plugin
export var emptyState = "_5y-d";
export var statCard = "_5y-c";
export var table = "_5y-0";
export var tableCell = "_5y-4";
export var tableCellClickable = "_5y-5 _5y-4";
export var tableCellDefault = "_5y-6 _5y-4";
export var tableCellEmpty = "_5y-8";
export var tableCellWithValue = "_5y-7";
export var tableContainer = "_5y-e";
export var tableHeaderWeight = "_5y-1";
export var tableHeaderZone = "_5y-2";
export var tableRowHeader = "_5y-3";
export var viewModeButton = "_5y-9";
export var viewModeButtonActive = "_5y-a _5y-9";
export var viewModeButtonInactive = "_5y-b _5y-9";